import { loadLanguagePack } from '@americanexpress/one-app-ducks';
import MODULE_NAME from '../constants/moduleName';

const onEnterLoadIntl = ({ dispatch }) => async (props, replace, onLoadComplete) => {
  await dispatch(loadLanguagePack(MODULE_NAME, { fallbackLocale: 'en-US' }));
  onLoadComplete();
};

export default onEnterLoadIntl;
